<template>
  <tbody class="even:bg-gray-100 border-b text-xs">
    <tr>
      <td class="text-center align-text-top pt-2 px-4">
        {{ lineNumber }}
      </td>
      <td class="py-2 pr-8 align-text-top">
        <span>
          {{ invoiceLine.description }}
        </span>
      </td>
      <td class="py-2 pr-4 text-right align-text-top tabular-nums">
        {{ quantity }}
      </td>
      <td class="py-2 pr-4 text-right align-text-top tabular-nums whitespace-nowrap">
        {{ currencyFormattedPricePerUnit }}
      </td>
      <td class="py-2 pr-4 text-right align-text-top tabular-nums whitespace-nowrap">
        {{ currencyFormattedNetAmount }}
      </td>
      <td class="py-2 pr-4 text-right align-text-top tabular-nums whitespace-nowrap">
        {{ percentFormattedVatRate }}
      </td>
      <td class="py-2 pr-4 text-right align-text-top tabular-nums whitespace-nowrap">
        {{ currencyFormattedVatAmount }}
      </td>
      <td class="py-2 pr-4 text-right align-text-top tabular-nums whitespace-nowrap">
        {{ currencyFormattedTotalAmount }}
      </td>
    </tr>
    <!-- <tr>
      <td />
      <td
        class="pb-2 pr-4"
        colspan="2"
      >
        <table class="table-auto w-full border-collapse">
          <tbody>
            <SubInvoiceLine
              v-for="(child, idx) in includedDirectChildren"
              :key="`included_direct_${idx}`"
              :invoice-line="child"
            />
            <SubInvoiceLine
              v-for="(child, idx) in chargedExtraDirectChildren"
              :key="`extra_charged_direct_${idx}`"
              :invoice-line="child"
            />
            <SubInvoiceLine
              v-for="(child, idx) in chargedExtraIndirectChildren"
              :key="`extra_charged_indirect_${idx}`"
              :invoice-line="child"
            />
          </tbody>
        </table>
      </td>
    </tr> -->
  </tbody>
</template>

<script>
/* eslint-disable no-underscore-dangle */
// import SubInvoiceLine from './SubInvoiceLine.vue';
import Numbro from 'numbro';

export default {
  components: {
    // SubInvoiceLine,
  },
  props: {
    lineNumber: {
      type: Number,
      default: 1,
    },
    invoiceLine: {
      type: Object,
      required: true,
    },
    invoiceLines: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    product() {
      if (typeof this.invoiceLine.productId !== 'string') {
        return null;
      }

      return this.$store.state.entities.products.byId[this.invoiceLine.productId];
    },
    quantity() {
      return this.invoiceLine.quantity;
    },
    pricePerUnit() {
      return this.invoiceLine.pricePerUnit;
    },
    currencyFormattedPricePerUnit() {
      return Numbro(this.pricePerUnit).formatCurrency({ mantissa: 2, spaceSeparated: true });
    },
    netAmount() {
      return this.pricePerUnit * this.quantity;
    },
    currencyFormattedNetAmount() {
      return Numbro(this.netAmount).formatCurrency({ mantissa: 2, spaceSeparated: true });
    },
    vatRate() {
      return this.invoiceLine.vatRate;
    },
    percentFormattedVatRate() {
      return Numbro(this.vatRate).format({
        output: 'percent',
        mantissa: 0,
      });
    },
    vatAmount() {
      return this.netAmount * this.vatRate;
    },
    currencyFormattedVatAmount() {
      return Numbro(this.vatAmount).formatCurrency({ mantissa: 2, spaceSeparated: true });
    },
    totalAmount() {
      return this.netAmount + this.vatAmount;
    },
    currencyFormattedTotalAmount() {
      return Numbro(this.totalAmount).formatCurrency({ mantissa: 2, spaceSeparated: true });
    },
    directChildren() {
      return this.invoiceLines.filter((invoiceLine) => {
        if ('uuid' in this.invoiceLine) {
          return invoiceLine.parentInvoiceLineId === this.invoiceLine.uuid;
        }

        return invoiceLine._parentInvoiceLineId === this.invoiceLine._uuid;
      });
    },
    includedDirectChildren() {
      return this.directChildren.filter((invoiceLine) => invoiceLine.pricePerUnit === 0);
    },
    chargedExtraDirectChildren() {
      return this.directChildren.filter((invoiceLine) => invoiceLine.pricePerUnit !== 0);
    },
    indirectChildren() {
      return this.invoiceLines.filter(this.isIndirectChild);
    },
    includedIndirectChildren() {
      return this.indirectChildren.filter((invoiceLine) => invoiceLine.pricePerUnit === 0);
    },
    chargedExtraIndirectChildren() {
      return this.indirectChildren.filter((invoiceLine) => invoiceLine.pricePerUnit !== 0);
    },
  },
  methods: {
    isIndirectChild(invoiceLine) {
      if (
        this.directChildren.some((directInvoiceLine) =>
          this.isDirectChildOfInvoiceLine(invoiceLine, directInvoiceLine)
        )
      ) {
        return true;
      }

      const parentInvoiceLine = this.invoiceLines.find((o) =>
        this.isDirectChildOfInvoiceLine(invoiceLine, o)
      );

      if (typeof parentInvoiceLine === 'undefined') {
        return false;
      }

      return this.isIndirectChild(parentInvoiceLine);
    },
    isDirectChildOfInvoiceLine(invoiceLine, parentInvoiceLine) {
      if ('uuid' in parentInvoiceLine) {
        return invoiceLine.parentInvoiceLineId === parentInvoiceLine.uuid;
      }

      return invoiceLine._parentInvoiceLineId === parentInvoiceLine._uuid;
    },
  },
};
</script>
